
import Qrcode from '@/components/Qrcode/index.vue';

export default {
  components: {
    Qrcode: Qrcode
  },

  props: {
    url: {
      type: String,
      required: true
    },
    title: {
      type: String
    }
  },

  data: function data() {
    return {};
  },


  computed: {
    qrcodeAttrs: function qrcodeAttrs() {
      return {
        text: this.url
      };
    }
  }
};